module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-dialog--center",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "el-dialog__header"
  }, [_vm._t("title", [_c('span', {
    staticClass: "el-dialog__title"
  }, [_vm._v(_vm._s(_vm.title || '提示'))])]), _vm._v(" "), _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "the-height el-dialog__body no-padding"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "el-dialog__footer"
  }, [_vm._t("footer", [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$parent.$emit('close')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.$emit('close')
      }
    }
  }, [_vm._v("确 定")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144f67ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog/TemplateDialogWraper.vue
// module id = 711
// module chunks = 20